import React from 'react';

import {
  BaseEdge,
  EdgeLabelRenderer,
  EdgeProps,
  getBezierPath,
} from 'reactflow';

export function VmLinkEdge({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  data,
}: EdgeProps) {
  const [edgePath] = getBezierPath({
    sourceX,
    sourceY,
    targetX,
    targetY,
  });

  // ✅ Plaats label net boven VM-anker
  const LABEL_OFFSET_Y = -2; // px boven de VM-handle

  return (
    <>
      <BaseEdge id={id} path={edgePath} />

      <EdgeLabelRenderer>
        <div
          className="nodrag nopan"
          style={{
            position: 'absolute',
            transform: `translate(-50%, -100%) translate(${targetX}px, ${
              targetY + LABEL_OFFSET_Y
            }px)`,
            pointerEvents: 'none',
          }}
        >
          <div
            className="
              px-2 py-0.5 text-[11px]
              bg-white dark:bg-slate-800
              border border-slate-300 dark:border-slate-600
              rounded-md shadow-sm
            "
          >
            {data?.ip && (
              <div className="text-slate-500 dark:text-slate-400">
                {data.ip}
              </div>
            )}
          </div>
        </div>
      </EdgeLabelRenderer>
    </>
  );
}

export default VmLinkEdge;
